export const EMPLOYEES_ROOT = '/employees'
export const EMPLOYEES_SCHEDULING_ROUTE = '/staff/scheduling'

export const EDIT_EMPLOYEE = '/employees/edit/:id'
export const ADD_EMPLOYEE = '/employees/create'
